<template>
  <div
    :id="'contenteditable' + unique"
    contenteditable="false"
    class="content-editable-select"
    style="height: 30px; display: flex; align-items: center"
  ></div>
</template>

<script>
export default {
  name: "ContentEditable",
  props: {
    prevalue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      unique: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    };
  },
  watch: {
    prevalue: {
      handler(val) {
        if (val != "" && val) {
          // console.log(val,'preval');
          this.$nextTick(() => {
            // console.log(document.getElementById('textEditor').innerHTML,'HTML');
            document.getElementById("contenteditable" + this.unique).innerHTML =
              val;
          });
        }
        // this.modal_height = val;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
